import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Header from './Header';
import { Typography, Button } from '@material-ui/core';
import List from './List';
import { Link } from 'react-router-dom';

const styles = theme => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(2),
  },
  caption: {
    marginTop: theme.spacing(10),
    width: "calc(80vmin)"
  }
});

class Home extends React.Component {
  state = { list:null };

  render() {
    const { classes, user, db } = this.props;
    if (!user) {
      return (
        <React.Fragment>
          <Header user={user} />
          <Grid container justify="center" alignItems="center" direction="row" className={classes.root}>
              <Grid item className={classes.caption}>
                <Typography component="h2" variant="h5" gutterBottom>
                  Welcome Speech Bubbles                
                </Typography>
                <Typography gutterBottom>
                  This service allows you to create new type of internet contents
                  with "speech bubbles", equivalent to series of Tweets.                
                </Typography>
                <Typography gutterBottom>
                  Please&nbsp;
                    <Button variant="contained" color="primary" className={classes.button} 
                          component={Link} to="/login">Login
                    </Button> to create your own Speech Bubbles.                
                </Typography>

              </Grid>
          </Grid>
        </React.Fragment>
      );
    }    
    
    return (
      <React.Fragment>
        <Header user={user} />
        <Grid container justify="center" alignItems="center" direction="row" className={classes.root}>
            <Grid item>
              <Typography component="h2" variant="h5" gutterBottom>
                  Your Artciles                
              </Typography>
              <List user={user} db={db} />
            </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Home);
